/** Path prefixes shared by the route tables of every module file. Segments are always encoded. */

export const API_V1 = '/api/v1';

/** `/api/v1/evidence-pages/{slug}`. */
export function pagePath(slug: string): string {
  return `${API_V1}/evidence-pages/${encodeURIComponent(slug)}`;
}

/** `/api/v1/questions/{id}`. */
export function questionPath(id: string): string {
  return `${API_V1}/questions/${encodeURIComponent(id)}`;
}
